import {GET_CANDIDATE_INTERVIEW_DETAILS,GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS,GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE,POST_CANDIDATE_STAGE,POST_CANDIDATE_STAGE_SUCCESSFULL,POST_CANDIDATE_STAGE_FAILURE,GET_CURRENT_CANDIDATE_STATUS,GET_CURRENT_CANDIDATE_STATUS_SUCCESSFULL,GET_CURRENT_CANDIDATE_STATUS_FAILURE,POST_CANDIDATE_FEEDBACK,POST_CANDIDATE_FEEDBACK_SUCCESSFULL,POST_CANDIDATE_FEEDBACK_FAILURE,GET_CANDIDATE_COMMENT_LIST,GET_CANDIDATE_COMMENT_LIST_SUCCESSFULL,GET_CANDIDATE_COMMENT_LIST_FAILURE,POST_COMMENT_ON_CANDIDATE,POST_COMMENT_ON_CANDIDATE_SUCCESSFULL,POST_COMMENT_ON_CANDIDATE_FAILURE, UPDATE_CANDIDATE_MAPPING_STATUS, UPDATE_CANDIDATE_MAPPING_STATUS_SUCCESS, UPDATE_CANDIDATE_MAPPING_STATUS_FAILED} from "./actionTypes"




export const getCandidateInterviewDetails = (id) => {
    return {
      type: GET_CANDIDATE_INTERVIEW_DETAILS,
      payload:id
    }
  }
export const getCandidateInterviewDetailsSuccess = interviewDetails => {
    return {
      type: GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS,
      payload: interviewDetails,
    }
  }
export const getCandidateInterviewDetailsFailure = error => {
    return {
      type: GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE,
      payload:  error ,
    }
  }

  export const postCandidateStage=(obj)=>{
    return{
      type:POST_CANDIDATE_STAGE,
      payload:obj
    }

  }

  export const postCandidateStageSuccess=(res)=>{
    return{
      type:POST_CANDIDATE_STAGE_SUCCESSFULL,
      payload:res,
    }

  }

  export const postCandidateStageFailure=(error)=>{
    return{
      type:POST_CANDIDATE_STAGE_FAILURE,
      payload:error
    }
  }
  
  export const getCurrentCandidateStatus=(obj)=>{
    return{
      type:GET_CURRENT_CANDIDATE_STATUS,
      payload:obj
    }
  }

  export const getCurrentCandidateStatusSuccess=(res)=>{
    return{
      type:GET_CURRENT_CANDIDATE_STATUS_SUCCESSFULL,
      payload:res
    }
  }
  
  export const getCurrentCandidateStatusFailure=(error)=>{
    return{
      type:GET_CURRENT_CANDIDATE_STATUS_FAILURE,
      payload:error
    }
  }

  export const postCandidateFeedback=(obj)=>{
    return{
      type:POST_CANDIDATE_FEEDBACK,
      payload:obj
    }
  }

  export const postCandidateFeedbackSuccessfull=(res)=>{
    return{
      type:POST_CANDIDATE_FEEDBACK_SUCCESSFULL,
      payload:res
    }
  }

  export const postCandidateFeedbackFailure=(error)=>{
    return{
      type:POST_CANDIDATE_FEEDBACK_FAILURE,
      payload:error
    }
  }

  export const getCandidateCommentsList=(obj)=>{
    return{
      type:GET_CANDIDATE_COMMENT_LIST,
      payload:obj

    }
  }

  export const getCandidateCommentsListSuccessfull=(obj)=>{
    return{
      type:GET_CANDIDATE_COMMENT_LIST_SUCCESSFULL,
      payload:obj
    }
  }

  export const getCandidateCommentsListFailure=(error)=>{
    return{
      type:GET_CANDIDATE_COMMENT_LIST_FAILURE,
      payload:error
    }
  }

  export const postCommentOnCandidate=(obj)=>{
    return{
      type:POST_COMMENT_ON_CANDIDATE,
      payload:obj
    }
  }

  export const postCommentOnCandidateSuccessfull=(obj)=>{
    return{
      type:POST_COMMENT_ON_CANDIDATE_SUCCESSFULL,
      payload:obj
    }
  }

  export const postCommentOnCandidateFailure=(error)=>{
    return{
    type:POST_COMMENT_ON_CANDIDATE_FAILURE,
    payload:error

    }
  }
    export const candidateMappingStatusUpdate=(obj)=>{
      return{
        type:UPDATE_CANDIDATE_MAPPING_STATUS,
        payload:obj
      }
    }
  
    export const candidateMappingStatusUpdateSuccessfull=(obj)=>{
      return{
        type:UPDATE_CANDIDATE_MAPPING_STATUS_SUCCESS,
        payload:obj
      }
    }
  
    export const candidateMappingStatusUpdateFalied=(error)=>{
      return{
      type:UPDATE_CANDIDATE_MAPPING_STATUS_FAILED,
      payload:error
  
      }

  }